import { __rest } from "tslib";
import React from "react";
import { View, Text } from "react-native";
import PropTypes from "prop-types";
import { textStyle } from '../v2/theme';
var PnmacPageBubble = function (_a) {
  var text = _a.text,
    children = _a.children,
    ariaLevel = _a.ariaLevel,
    accessibilityRole = _a.accessibilityRole,
    containerStyles = _a.containerStyles,
    rest = __rest(_a, ["text", "children", "ariaLevel", "accessibilityRole", "containerStyles"]);
  return /*#__PURE__*/React.createElement(View, {
    testID: "pageBubble",
    nativeID: rest.idTag1,
    accessibilityRole: accessibilityRole,
    role: accessibilityRole,
    "aria-level": ariaLevel,
    style: [{
      marginLeft: 20,
      marginTop: 20,
      marginBottom: 10
    }, containerStyles]
  }, /*#__PURE__*/React.createElement(View, {
    nativeID: rest.idTag2,
    accessibilityLabel: text
  }, /*#__PURE__*/React.createElement(Text, {
    style: textStyle.pageTitle,
    nativeID: rest.idTag3
  }, text)), children);
};
PnmacPageBubble.propTypes = {
  text: PropTypes.string,
  ariaLevel: PropTypes.string,
  accessibilityRole: PropTypes.string,
  containerStyles: PropTypes.oneOfType([PropTypes.string, PropTypes.array, PropTypes.object])
};
export default PnmacPageBubble;